import en from "./en.json";
import enLocale from "element-ui/lib/locale/lang/en";
export default {
  ...en,
  ...enLocale,
};
